import AuthService from '@/modules/authentication/services/auth.service'
import ProjectService from '@/services/project.service'
import { userActionTypes } from '../actionTypes'
import AgentService from '@/services/agent.service'
import AppService from '@/services/app.service'

let types = userActionTypes

const state = {
    projects: [],
    activeProject: null,
    agentList: []
}

const mutations = {
    [types.PROJECTS]: (state, projects) => {
        state.projects = projects
        state.isProjectsLoaded = true
    },
    [types.ACTIVE_PROJECT]: (state, project) => {
        state.activeProject = project
        ProjectService.setLocalActiveProjectId(project.id)
    },
    [types.AGENT_LIST]: (state, agentList) => {
        state.agentList = agentList
    }
}

const actions = {
    [types.GET_PROJECTS] ({ commit }) {
        if (AuthService.getToken()) {
            return new Promise((resolve, reject) => {
                ProjectService.getProjects().then(res => {
                    commit(types.PROJECTS, res.data)
                    resolve()
                }).catch(err => {
                    commit(types.PROJECTS, [])
                    reject(err)
                })
            })
        } else {
            return null
        }
    },
    [types.CURRENT_PROJECT_ID] ({ commit }, projectId) {
        commit(types.CURRENT_PROJECT_ID, projectId)
        return true
    },
    [types.GET_AGENT_LIST] ({ commit, state }) {
        if (state.agentList && state.agentList.length > 0) {
            // do nothing, agentList already fetched
        } else {
            AgentService.getAgentList().then(
                result => {
                    commit(types.AGENT_LIST, result.data.map(item => {
                        return {
                            text: item.email,
                            value: item.id
                        }
                    }))
                },
                AppService.handleRequestError(window.vueapp.$t('canNotLoad', { item: window.vueapp.$t('agent') }))
            )
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
